import * as actionTypes from './actionTypes';

interface State {
  value: number;
  data: any;
}

const initialState: State = {
  value: 0,
  data: {}
}

export const priceTotal = (state = initialState, action): State => {
  switch (action.type) {
    case actionTypes.UPDATE_PRICE_TOTAL:
      return {
        ...state,
        value: action.value
      }
    case actionTypes.SET_PRICE_TOTAL_BY_CHANNEL:
      return {
        ...state,
        data: {
          ...state.data,
          [action.id]: {...action.data}
        }
      }
    case actionTypes.CLEAR_PRICE_TOTAL:
      return {
        ...state,
        data: {}
      }
    default:
      return state;
  }
}
